import Ajax from "@/api/ajax";
export default{
    //获取区域码
    salesmanList(params) {
        return Ajax.post("/Home/salesmanList", params);
    }
}